function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import buildResponses from '@unite-us/surveyjs/dist/components/Renderer/buildResponses';
import { BaseCard, BaseCardBody, InputField, OverlaySpinner } from '@unite-us/ui';
import { isEmpty } from 'lodash';
import ScreeningMenuInfo from './components/ScreeningMenuInfo';
import FormMenuOptions from '../../common/FormMenuOptions';
import ScreeningFormRenderer from '../../common/ScreeningFormRenderer';
import { findTemplateById, updateScreen } from '../../api/api';
import { STATUSES, TYPES, singletonAnswers } from '../../common/constants';
import screeningInitialValues from '../../common/utils/screeningInitialValues';
import { APP_ENVIRONMENT, CALLBACKS } from '../../api/config';
import { formatDateIfNeeded } from '../../utils';
import { validateDuration, hasSingletonAnswerError } from '../../common/utils/validateRequiredQuestions';
function ScreeningFormUpdate(_ref) {
  var _screening$decline_re, _screening$decline_re2, _screening$decline_re3, _screening$decline_re4;
  var setScreening = _ref.setScreening,
    screening = _ref.screening,
    setNeeds = _ref.setNeeds,
    isFetching = _ref.isFetching,
    setIsSaving = _ref.setIsSaving,
    isSaving = _ref.isSaving,
    contactId = _ref.contactId,
    flags = _ref.flags;
  var surveyRef = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    editMode = _useState2[0],
    setEditMode = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    allowEdit = _useState4[0],
    setAllowEdit = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    screeningConsent = _useState6[0],
    setScreeningConsent = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    screenStatus = _useState8[0],
    setScreenStatus = _useState8[1];
  var _useState9 = useState(undefined),
    _useState10 = _slicedToArray(_useState9, 2),
    template = _useState10[0],
    setTemplate = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    error = _useState12[0],
    setError = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    idOfAnswers = _useState14[0],
    setIdOfAnswers = _useState14[1];
  var newStatus = useRef(undefined);
  var _useState15 = useState(),
    _useState16 = _slicedToArray(_useState15, 2),
    screeningDuration = _useState16[0],
    setScreeningDuration = _useState16[1];
  var notifiy = CALLBACKS.notifiy;
  var handleDurationChange = function handleDurationChange(event) {
    var rawValue = event.target.value.trim();
    if (rawValue === '') {
      setScreeningDuration('');
      return;
    }
    var parsedValue = Math.max(0, Math.min(Number(rawValue), 99));
    setScreeningDuration(parsedValue);
  };
  var source = APP_ENVIRONMENT.source;
  var notify = CALLBACKS.notify;
  useEffect(function () {
    if (screening && screenStatus !== screening.status) setScreenStatus(screening.status);
    (screening === null || screening === void 0 ? void 0 : screening.status) === STATUSES.DECLINED ? setScreeningConsent(false) : setScreeningConsent(true);
    screening && findTemplate(screening.template_id);
    var idsOfSpecificAnswers = [];
    if (!isEmpty(screening)) {
      screening.questions.forEach(function (question) {
        if (question.type === 'select_multiple') {
          question.options.forEach(function (option) {
            if (singletonAnswers.includes(option.value)) {
              idsOfSpecificAnswers.push(option.id);
            }
          });
        }
      });
    }
    setIdOfAnswers(idsOfSpecificAnswers);
    setScreeningDuration(screening === null || screening === void 0 ? void 0 : screening.duration);
  }, [screening]);
  var handleOnCancel = function handleOnCancel() {
    setEditMode(false);
  };
  var handleOnEditClick = function handleOnEditClick() {
    setEditMode(!editMode);
  };
  var handleOnSubmitDraft = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setScreenStatus(STATUSES.DRAFT);
            onSubmit(STATUSES.DRAFT);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleOnSubmitDraft() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleOnSubmitComplete = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setScreenStatus(STATUSES.COMPLETE);
            onSubmit(STATUSES.COMPLETE);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleOnSubmitComplete() {
      return _ref3.apply(this, arguments);
    };
  }();
  var findTemplate = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(templateId) {
      var templateInfo;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return findTemplateById(templateId);
          case 2:
            templateInfo = _context3.sent;
            setTemplate(templateInfo);
            setAllowEdit(templateInfo.survey_json.active);
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function findTemplate(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var getValue = function getValue(questionId, value) {
    var question = screening.questions.find(function (q) {
      return q.id === questionId;
    });
    if (question.type === TYPES.NUMBER) {
      return parseInt(value);
    }
    if (question.type === TYPES.DATE) {
      return formatDateIfNeeded(value);
    }
    return value;
  };
  var getOptionId = function getOptionId(questionId, valueId) {
    var question = screening.questions.find(function (q) {
      return q.id === questionId;
    });
    if (question.type === TYPES.CHECKBOX || question.type === TYPES.DROPDOWN_MULTISELECT || question.type === TYPES.SELECT_MULTIPLE) {
      return valueId && valueId;
    }
    return valueId && valueId[0];
  };
  var getOption = function getOption(answer) {
    var _screening$questions$ = screening.questions.find(function (q) {
        return q.id === answer.id;
      }),
      type = _screening$questions$.type;
    if (type === TYPES.DROPDOWN || type === TYPES.SELECT || type === TYPES.RADIOGROUP) {
      return '';
    }
    return [];
  };
  var onSavingScreenError = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            notify.error("We've encountered an unexpected problem saving the screening. Please try again.");
            setIsSaving(false);
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function onSavingScreenError() {
      return _ref5.apply(this, arguments);
    };
  }();
  var onSavingScreenSuccess = function onSavingScreenSuccess(response) {
    setEditMode(false);
    setScreening(response === null || response === void 0 ? void 0 : response.screen);
    setScreenStatus(response === null || response === void 0 ? void 0 : response.screen.status);
    setNeeds(response === null || response === void 0 ? void 0 : response.identifiedNeeds);
    setIsSaving(false);
  };
  var processAnsweres = function processAnsweres(data) {
    var result = {
      answers: [],
      questionIds: []
    };
    Object.keys(data).forEach(function (key) {
      var question = screening.questions.find(function (q) {
        return q.id === key;
      });
      if (question && question.type === 'select_multiple' && !Array.isArray(data[key])) result.answers.push({
        question_id: key,
        option_id: [data[key]]
      });else {
        result.answers.push({
          question_id: key,
          option_id: data[key]
        });
      }
      result.questionIds.push(key);
    });
    return result;
  };
  var generateAnswers = function generateAnswers(questionIds, oldAnswers) {
    var emptyAnswers = [];
    // Loop through oldAnswers and check if the question_id is in the questionIds array
    oldAnswers.forEach(function (oldAnswer) {
      if (!questionIds.includes(oldAnswer.id) && oldAnswer.type !== TYPES.DATE) {
        emptyAnswers.push({
          question_id: oldAnswer.id,
          option_id: getOption(oldAnswer)
        });
      }
    });
    return emptyAnswers;
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(screenStatus) {
      var _flags$scrn468Screeni, _template$survey_json;
      var survey, responses, answers, isDurationValid, shouldValidateDuration, multiselectId, _answers$, questionIds, emptyAnswers, decline_reason, duration;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            setIsSaving(true);
            survey = surveyRef.current;
            responses = buildResponses(survey);
            answers = responses.map(function (response) {
              var _screening$questions$2;
              var type = (_screening$questions$2 = screening.questions.find(function (question) {
                return question.id === response.id;
              })) === null || _screening$questions$2 === void 0 ? void 0 : _screening$questions$2.type;
              if (type === TYPES.DATE && response.value === '') return null;
              return {
                question_id: response.id,
                option_id: getOptionId(response.id, response.valueId),
                value: getValue(response.id, response.value)
              };
            }).filter(Boolean);
            shouldValidateDuration = (_flags$scrn468Screeni = flags === null || flags === void 0 ? void 0 : flags.scrn468ScreeningTimeTrackingEnabled) !== null && _flags$scrn468Screeni !== void 0 ? _flags$scrn468Screeni : false;
            if (!shouldValidateDuration) {
              isDurationValid = true;
            } else {
              isDurationValid = validateDuration(screenStatus, screeningDuration);
            }
            multiselectId = template && ((_template$survey_json = template.survey_json.pages[0].elements.find(function (x) {
              return x.type === 'dropdown-multiselect';
            })) === null || _template$survey_json === void 0 ? void 0 : _template$survey_json.name);
            surveyRef.current && multiselectId && surveyRef.current.onValidateQuestion.add(function (survey, options) {
              if (options.name === multiselectId) {
                if (hasSingletonAnswerError(options.value)) {
                  options.error = 'Please review your answer';
                }
              }
            });
            if (!(screenStatus === STATUSES.COMPLETE && survey.hasErrors() || !isDurationValid)) {
              _context5.next = 12;
              break;
            }
            setIsSaving(false);
            _context5.next = 18;
            break;
          case 12:
            // TO DO
            // const { answers, questionIds } = processAnsweres(answers);
            questionIds = responses.map(function (response) {
              return response.id;
            });
            emptyAnswers = generateAnswers(questionIds, screening.questions);
            decline_reason = newStatus.current === 'declined' ? (_answers$ = answers[0]) === null || _answers$ === void 0 ? void 0 : _answers$.option_id : undefined;
            duration = screeningDuration !== undefined ? parseInt(screeningDuration, 10) : undefined;
            _context5.next = 18;
            return updateScreen({
              screeningId: screening.id,
              status: screenStatus,
              answers: screenStatus !== 'declined' ? answers.concat(emptyAnswers) : undefined,
              decline_reason: decline_reason,
              source: source,
              onError: onSavingScreenError,
              onSuccess: onSavingScreenSuccess,
              personId: contactId,
              duration: duration
            });
          case 18:
            setIsSaving(false);
          case 19:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function onSubmit(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();
  var isFormDeclined = screenStatus === STATUSES.DECLINED;
  var textDeclined = /*#__PURE__*/React.createElement("div", {
    className: "border-t border-gray-200 pt-4 m-12"
  }, /*#__PURE__*/React.createElement("p", {
    className: "strong leading-5 mb-3"
  }, "Reason for Decline"), /*#__PURE__*/React.createElement("p", {
    className: "font-normal text-sm"
  }, screening === null || screening === void 0 || (_screening$decline_re = screening.decline_reason) === null || _screening$decline_re === void 0 ? void 0 : _screening$decline_re.human_text, ":", ' ', screening === null || screening === void 0 || (_screening$decline_re2 = screening.decline_reason) === null || _screening$decline_re2 === void 0 ? void 0 : _screening$decline_re2.secondary_text), !isEmpty(screening === null || screening === void 0 || (_screening$decline_re3 = screening.decline_reason) === null || _screening$decline_re3 === void 0 ? void 0 : _screening$decline_re3.note) && /*#__PURE__*/React.createElement("div", {
    className: "mt-8"
  }, /*#__PURE__*/React.createElement("p", {
    className: "strong mb-3 "
  }, "Additional information"), /*#__PURE__*/React.createElement("p", {
    className: "font-normal text-sm  "
  }, screening === null || screening === void 0 || (_screening$decline_re4 = screening.decline_reason) === null || _screening$decline_re4 === void 0 ? void 0 : _screening$decline_re4.note)));
  return /*#__PURE__*/React.createElement(BaseCard, null, /*#__PURE__*/React.createElement(ScreeningMenuInfo, {
    screening: screening,
    isFetching: isFetching,
    handleOnEditClick: handleOnEditClick,
    editMode: editMode,
    allowEdit: allowEdit,
    title: template && template.survey_json.title || '',
    personId: contactId
  }), /*#__PURE__*/React.createElement(BaseCardBody, {
    withPadding: true
  }, /*#__PURE__*/React.createElement(OverlaySpinner, {
    text: "Saving screening",
    show: isSaving
  }), !isFetching && !isSaving && isFormDeclined && textDeclined, !isFetching && !isFormDeclined && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScreeningFormRenderer, {
    editMode: editMode,
    idSingletonAnswer: idOfAnswers,
    template: template,
    screening: screening,
    ref: surveyRef
  }), (screening === null || screening === void 0 ? void 0 : screening.questions) && (flags === null || flags === void 0 ? void 0 : flags.scrn468ScreeningTimeTrackingEnabled) && /*#__PURE__*/React.createElement("div", null, editMode ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-start gap-8 mt-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-[0_0_50%]"
  }, /*#__PURE__*/React.createElement(InputField, {
    id: "screeningDuration",
    label: "SCREENING DURATION",
    type: "number",
    value: screeningDuration === null ? '' : screeningDuration,
    onChange: handleDurationChange,
    min: "1",
    required: true,
    hint: "Enter the total time (in minutes) you spent directly interacting with the client for this screening."
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "unit-text mb-2 self-start"
  }, "UNIT"), /*#__PURE__*/React.createElement("span", {
    className: "minutes-text self-start"
  }, "Minutes"))) : /*#__PURE__*/React.createElement("div", {
    className: "ui-form-renderer-question-display"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ui-form-renderer-question-display__label"
  }, "Screening Duration"), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ui-form-renderer-question-display__value"
  }, (screening === null || screening === void 0 ? void 0 : screening.duration) || '-'), /*#__PURE__*/React.createElement("span", {
    className: "ui-form-renderer-question-display__value"
  }, "Minutes")))), /*#__PURE__*/React.createElement(FormMenuOptions, {
    editMode: editMode,
    isFetching: isFetching,
    isSaving: isSaving,
    handleOnCancel: handleOnCancel,
    handleOnSubmitComplete: handleOnSubmitComplete,
    handleOnSubmitDraft: handleOnSubmitDraft,
    screeningConsent: screeningConsent,
    disableDraftButton: error,
    disabledOnSubmit: error
  }))));
}
ScreeningFormUpdate.propTypes = {
  isFetching: PropTypes.bool,
  allowEdit: PropTypes.bool,
  handleOnSubmit: PropTypes.func,
  flags: PropTypes.shape({
    scrn468ScreeningTimeTrackingEnabled: PropTypes.bool
  })
};
ScreeningFormUpdate.defaultProps = {
  isFetching: true,
  afterSubmit: null,
  contextType: 'person'
};
export default ScreeningFormUpdate;
//# sourceMappingURL=index.js.map